module.exports = __webpack_public_path__ + "static/media/AADIL A.248b4d9d.PNG";